"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-debugger */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Annotator = exports.encodeAs = exports.Encoding = exports.consume = exports.encode = exports.Length = exports.FieldNumber = void 0;
require("reflect-metadata");
const buffer_1 = require("../common/buffer");
const encodable_1 = require("./encodable");
const encoding_1 = require("./encoding");
__exportStar(require("./encodable"), exports);
__exportStar(require("./encoding"), exports);
exports.FieldNumber = new encodable_1.Uint();
exports.Length = new encodable_1.Uint();
function encode(target) {
    const parts = [];
    consume(target, (field, value) => {
        parts.push((0, encoding_1.uvarintMarshalBinary)(field.number));
        parts.push(field.type.encode(value));
    });
    return buffer_1.Buffer.concat(parts);
}
exports.encode = encode;
function consume(target, consume) {
    const enc = Encoding.get(target);
    if (!enc)
        throw new Error("cannot encode object: no metadata");
    for (const field of enc.fields) {
        encodeField(target, field, consume);
    }
}
exports.consume = consume;
function encodeField(target, field, consume) {
    const value = field.type instanceof Embedded ? target : target[field.name];
    if (!field.repeatable) {
        encodeValue(value, field, consume);
        return;
    }
    if (value)
        for (const item of value)
            encodeValue(item, field, consume);
}
function encodeValue(value, field, consume) {
    switch (true) {
        case field.type instanceof encodable_1.Hash:
            if (!field.keepEmpty && isZeroHash(value))
                return;
            break;
        case field.type instanceof Embedded:
            break;
        default:
            if (!field.keepEmpty && !value)
                return;
            break;
    }
    consume(field, value);
}
function isZeroHash(value) {
    if (!value)
        return true;
    for (const v of value) {
        if (v !== 0)
            return false;
    }
    return true;
}
class Embedded {
    constructor(field) {
        this.field = field;
        this.embedding = true;
    }
    encode(value) {
        const parts = [];
        this.consume(value, (field, value) => {
            parts.push((0, encoding_1.uvarintMarshalBinary)(field.number));
            parts.push(field.type.encode(value));
        });
        return (0, encoding_1.bytesMarshalBinary)(buffer_1.Buffer.concat(parts));
    }
    consume(value, consumer) {
        for (const item of this.field.embedded) {
            encodeField(value, item, consumer);
        }
    }
}
class Encoding {
    constructor() {
        this.fields = [];
    }
    static get(target) {
        const proto = Object.getPrototypeOf(target);
        if (Reflect.hasOwnMetadata("encoding", proto))
            return Reflect.getMetadata("encoding", proto);
        return;
    }
    static forClass(target) {
        if (Reflect.hasOwnMetadata("encoding", target.prototype))
            return Reflect.getMetadata("encoding", target.prototype);
        return;
    }
    static set(target) {
        if (Reflect.hasOwnMetadata("encoding", target))
            return Reflect.getMetadata("encoding", target);
        const encoding = new Encoding();
        Reflect.defineMetadata("encoding", encoding, target);
        return encoding;
    }
    addField(number, props) {
        if (number.length > 2)
            throw new Error("multiply nested fields are not supported");
        if (number.length == 1) {
            this.fields.push({ number: number[0], ...props });
            return;
        }
        let field = this.fields.find((x) => x.number === number[0]);
        if (!field) {
            field = {
                number: number[0],
                type: {
                    encode() {
                        throw new Error("placeholder");
                    },
                },
                name: "",
                repeatable: false,
                keepEmpty: false,
                embedded: [],
            };
            (field.type = new Embedded(field)), this.fields.push(field);
        }
        field.embedded.push({ number: number[1], ...props });
    }
}
exports.Encoding = Encoding;
exports.encodeAs = {
    field(...number) {
        return new Annotator(number);
    },
};
class Annotator {
    constructor(number) {
        this.number = number;
        this.field = {
            repeatable: false,
            keepEmpty: false,
        };
    }
    get repeatable() {
        this.field.repeatable = true;
        return this;
    }
    get keepEmpty() {
        this.field.keepEmpty = true;
        return this;
    }
    get enum() {
        const add = (target, key, type) => Encoding.set(target).addField(this.number, {
            name: key,
            type: new encodable_1.Enum(type),
            ...this.field,
        });
        const annotator = (target, key) => add(target, key);
        annotator.of = (type) => (target, key) => add(target, key, type);
        return annotator;
    }
    get reference() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, {
                name: key,
                type: new encodable_1.Reference(),
                ...this.field,
            });
        };
    }
    get union() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Union(), ...this.field });
        };
    }
    get int() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Int(), ...this.field });
        };
    }
    get uint() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Uint(), ...this.field });
        };
    }
    get bool() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Bool(), ...this.field });
        };
    }
    get string() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.String(), ...this.field });
        };
    }
    get hash() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Hash(), ...this.field });
        };
    }
    get bytes() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Bytes(), ...this.field });
        };
    }
    get url() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Url(), ...this.field });
        };
    }
    get time() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.Time(), ...this.field });
        };
    }
    get duration() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, {
                name: key,
                type: new encodable_1.Duration(),
                ...this.field,
            });
        };
    }
    get bigInt() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.BigInt(), ...this.field });
        };
    }
    // asAny(target: any, key: PropertyKey) {
    //   Encoding.set(target).addField(this.number, { name: key, type: new Any, ...this.field });
    // }
    get rawJson() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.RawJson(), ...this.field });
        };
    }
    // asFloat(target: any, key: PropertyKey) {
    //   Encoding.set(target).addField(this.number, { name: key, type: new Float, ...this.field });
    // }
    get txid() {
        return (target, key) => {
            Encoding.set(target).addField(this.number, { name: key, type: new encodable_1.TxID(), ...this.field });
        };
    }
}
exports.Annotator = Annotator;
//# sourceMappingURL=index.js.map